import { Divider, IconButtonProps, Stack } from '@mui/material';
import { forwardRef, PropsWithChildren } from 'react';
import { SystemStyleObject } from '@mui/system';

interface Props {
  buttonProps?: IconButtonProps;
  sx?: SystemStyleObject;
}

export const ToggleFiltersToolbar = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, sx }, ref) => {
    return (
      <>
        <Stack
          direction="row"
          alignItems="flex-end"
          gap={2}
          mt={2}
          px={3}
          sx={sx}
          ref={ref}
          mb={-0.1}
        >
          {children}
        </Stack>
        <Divider />
      </>
    );
  }
);
